import Head from './pages/header'
import Bottom from './pages/bottom'
import MernHome from './mern/mern'
import Text from './mern/text'
import Map from './pages/map'
import Divider from './pages/divider'
import "./index.css"

function App() {
  return (
    <>
    <Head></Head>
    <MernHome></MernHome>
    <Text></Text>
    <Divider></Divider>
    <Map></Map>
    <Bottom></Bottom>
    </>
  );
}

export default App;
